export default {
  'welcome': 'Welcome'
}
